import importerStore from '@shared/importer/importer-store';
import { EventService } from '@modules/event/event-service';
import eventImporterFields from '@modules/event/event-importer-fields';
import { i18n } from '@shared/i18n';

export default importerStore(
  EventService.import,
  eventImporterFields,
  i18n('entities.event.importer.fileName'),
  i18n('entities.event.importer.hint'),
);
